import { moduleProviderFactory } from "core/providers";
import { NikoInventoryRequestEmailEdit } from "application/niko-inventory-request/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.niko-main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.niko-inventory-request.edit-email",
                        pattern: "/:facilityOrderId/:inventoryRequestType/niko-inventory-request",
                        component: NikoInventoryRequestEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "Inventory Request",
                                    route: 'master.app.main.facility-order.niko-inventory-request.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
						order: 3,
					}  
				]
			},
        ]
    });
})();
